import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { EjecutorService } from 'src/app/services/ejecutor.service';
import { EventMantenedorEjecutorService } from 'src/app/services/event-mantenedor-ejecutor.service';
@Component({
  selector: 'app-table-ejecutor',
  templateUrl: './table-ejecutor.component.html',
  styleUrls: ['./table-ejecutor.component.scss']
})
export class TableEjecutorComponent implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElementEjecutor: DataTableDirective;
  dtTriggerEjecutor: Subject<any> = new Subject();
  loadingEjecutor = false;
  searchT: string = "";
  pageActualEjecutor = 1
  ejecutorMantenedor: any;
  ejecutorFilter: any;
  ejecutor: any;
  ejecutorSelected: any;
  ejecutorIdSelected: number;
  creationMode: string;
  confirmationModalTittle: string;
  confirmationModalMessage: string;
  confirmationModalHasComment = false;
  confirmationModalHasOptions = false;
  confirmationModalisCommentObligatory = false;
  confirmationModalAccept: any;
  confirmationModalOptionLabel: string;
  confirmationModalOptions: { label: string, value: any }[];
  initialArrayEjecutor: any = [];
  inputMessageModal: string = "";
  constructor(private ejecutorService: EjecutorService,
    private modalService: NgbModal,
    private eventMantenedorEjecutorService: EventMantenedorEjecutorService) { }

  ngOnInit() {
    this.refreshEjecutor();

    if (this.eventMantenedorEjecutorService.subsVar == undefined) {
      this.eventMantenedorEjecutorService.subsVar = this.eventMantenedorEjecutorService.
        invokeFirstComponentFunction.subscribe(() => {
          this.refreshEjecutor();
        });
    }
  }

  ngAfterViewInit(): void {
    this.dtTriggerEjecutor.next();
  }

  ngOnDestroy(): void {
    this.dtTriggerEjecutor.unsubscribe();
  }
  changeSearch(e) {
    let valor = e.target.value
    console.log('Filtrando valores')
    console.log(e.target.value)
    console.log(valor.length)

    if (valor.length > 0) {
      this.pageActualEjecutor = 1;
      let word = valor.toLowerCase();
      this.ejecutorMantenedor = this.initialArrayEjecutor.filter((item) => {
        let str = item.ejecutorDescription
        str = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        return str.toLowerCase().search(word) > -1
      }
      )
      console.log('Registros encontrados')
      console.log(this.ejecutorMantenedor.length)
    } else {
      this.ejecutorMantenedor = this.initialArrayEjecutor;
    }

  }
  refreshEjecutor() {
    Promise.all([
      this.getEjecutorMantenedor()
    ])
      .then(results => {
        this.ejecutorMantenedor = results[0];
        this.ejecutorFilter = results[0];
        this.initialArrayEjecutor = results[0];
        this.rerenderEjecutor();
      })
      .catch(error => {
        this.loadingEjecutor = false;
        console.error(error);
      });
  }

  refreshEjecutorCreateOrUpdate(event) {
    this.inputMessageModal = event;
    this.refreshEjecutor();
  }


  getEjecutorMantenedor(): any {
    this.loadingEjecutor = true;
    return new Promise((resolve, reject) => {
      this.ejecutorService.getAllCategorias()
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  }
  rerenderEjecutor(): void {
    this.loadingEjecutor = false;
    this.inputMessageModal = "";
    this.dtElementEjecutor.dtInstance.then((dtInstanceEjecutor: DataTables.Api) => {
      dtInstanceEjecutor.destroy();
      this.dtTriggerEjecutor.next();
    });
  }
  onCreateEjecutor(modal: any, mode: string, ejecutor: any) {
    if (mode === 'Editar') {
      const request: JSON = {
        ejecutorId: ejecutor.ejecutorId,
        descripcion: ejecutor.ejecutorDescription,
        estado: ejecutor.status
      } as unknown as JSON;
      this.ejecutorSelected = request;
    } else {
      const request: JSON = {
        ejecutorId: null,
        descripcion: "",
        estado: 1// Estado habilitado para la ejecutor que se creará
      } as unknown as JSON;
      this.ejecutorSelected = request;
    }
    const modalOptions: NgbModalOptions = { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'lg' };
    this.creationMode = mode;
    this.modalService.open(modal, modalOptions);
  }
  openDeleteModalEjecutor(modal: any, ejecutor: any): void {
    this.ejecutor = ejecutor;
    this.confirmationModalHasComment = false;
    this.confirmationModalHasOptions = false;
    this.confirmationModalisCommentObligatory = false;
    this.ejecutorIdSelected = ejecutor.ejecutorId;
    this.confirmationModalTittle = 'Eliminar Ejecutor';
    this.confirmationModalMessage = `¿Seguro que desea eliminar el ejecutor "${ejecutor.ejecutorDescription}"?`;
    this.confirmationModalAccept = this.onDeleteEjecutor;
    this.openModal(modal);
  }
  openModal(modal: any, options: any = {}): void {
    const modalOptions = { ariaLabelledBy: 'modal-basic-title', centered: true, ...options };
    this.modalService.open(modal, modalOptions);
  }
  onDeleteEjecutor(): void {
    // const ejecutor = this.ejecutor;
    // this.loadingEjecutor = true;
    // const request: JSON = {
    //   ejecutor:
    //   {
    //     ejecutorId: ejecutor.ejecutorId,
    //     descripcion: ejecutor.ejecutorDescription,
    //     estado: 0
    //   }
    // } as unknown as JSON;
    this.ejecutorService.deleteEjecutor(this.ejecutor.ejecutorId)
      .then(() => {
        this.refreshEjecutor();
      })
      .catch(error => console.error(error));
  }
  getEstadoLabel(estado: boolean): string {
    if (estado) {
      return 'Habilitado';
    } else {
      return 'Deshabilitado';
    }
  }
}
